import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

// Create/update the stock card, then upload or remove its photo
export const saveVariant = async (editing, body, photo, photoRemoved) => {
  const r = editing ? await api.put(`/products/${editing.id}`, body) : await api.post("/products", body);
  const id = r.data.id;
  if (photo) {
    const fd = new FormData();
    fd.append("file", photo);
    try { await api.post(`/products/${id}/photo`, fd); }
    catch (e) { toast.error(e.response?.data?.detail || "Fotoğraf yüklenemedi"); }
  } else if (photoRemoved && editing?.photo_path) {
    await api.delete(`/products/${id}/photo`);
  }
};

export const SoleCardSelect = ({ soleCards, form, setForm }) => {
  const soleId = soleCards.find((s) => s.sole_code === form.sole_code && (s.sole_color || "") === (form.sole_color || ""))?.id || "__none";
  return (
    <div>
      <Label className="text-xs text-[#6B5B4A]">Taban (Taban Kartı)</Label>
      <Select value={soleId} onValueChange={(v) => {
        const s = soleCards.find((x) => x.id === v);
        setForm({ ...form, sole_code: s?.sole_code || "", sole_color: s?.sole_color || "" });
      }}>
        <SelectTrigger data-testid="color-sole-select" className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]">
          <SelectValue placeholder="Taban seçin..." />
        </SelectTrigger>
        <SelectContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118]">
          <SelectItem value="__none" data-testid="color-sole-option-none">Tabansız</SelectItem>
          {soleCards.map((s) => (
            <SelectItem key={s.id} value={s.id} data-testid={`color-sole-option-${s.id}`}>
              {s.sole_code}{s.sole_color ? ` · ${s.sole_color}` : ""}{s.supplier ? ` (${s.supplier})` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {soleCards.length === 0 && (
        <p className="text-[11px] text-[#8C7B68] mt-1">Taban kartı yok. <Link to="/taban" className="text-[#B45309] underline">Tabanlar</Link> sayfasından oluşturun.</p>
      )}
    </div>
  );
};
